import React from 'react';

export const TableRow = ({children}) => (
    <tr style={{
        height: '80px'
    }}>
        {children}
    </tr>
)